module.exports = __webpack_public_path__ + "img/06-chinese.b8e93e12.svg";